import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { fetchTeamMembers } from '@/api/v4/team.api';
import type { TeamMember } from '@/api/v4/team.api';
import type { CurrentUserStatus } from '@/api/v4/auth.api';
import { QueryKey } from '@/config/query-client';

import { teamIdState, teamMembersSortState } from '../team.state';

interface TeamMemberQuery {
  status: CurrentUserStatus;
}

export const useTeamMembersByStatus = (query: TeamMemberQuery) => {
  const teamId = useAtomValue(teamIdState);
  const { sort, direction } = useAtomValue(teamMembersSortState);

  return useQuery({
    queryKey: [QueryKey.TeamMembers, teamId, query.status, sort, direction],
    queryFn: async (): Promise<TeamMember[]> => {
      if (!teamId) return [];

      const teamMembers = await fetchTeamMembers(teamId, {
        status: query.status,
        ...(sort && { sort, direction }),
      });

      return teamMembers;
    },
    enabled: !!teamId,
    staleTime: 1000 * 60 * 5,
  });
};
